const items = [
  { num: "5.000+", label: "Khách hàng tin tưởng" },
  { num: "120M+", label: "Tổng tiền giải ngân (VND)" },
  { num: "98%", label: "Hồ sơ duyệt thành công" },
  { num: "24/7", label: "Hỗ trợ trực tuyến" },
];

export default function TrustBar() {
  return (
    <section className="relative -mt-12 z-20 px-6 md:px-10">
      <div className="bg-background-50 border border-background-200/70 rounded-3xl px-6 md:px-10 py-7 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4">
        {items.map((it, idx) => (
          <div
            key={it.label}
            className={`flex flex-col items-center text-center md:border-r last:border-r-0 md:border-background-200/70 ${
              idx === 1 || idx === 3 ? "md:border-r" : ""
            }`}
          >
            <p className="font-heading text-3xl md:text-4xl text-primary-600 leading-none">
              {it.num}
            </p>
            <p className="text-foreground-600 text-sm mt-3">{it.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}